import { Component, Input, QueryList, SimpleChanges, ViewChild, ViewChildren } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Store } from '@ngxs/store';
import { IORD_Order, PatchPartElementDto, Picklist, RTAOptions } from '../../interfaces/request.interface';
import { debounceTime, map, Observable, of, Subject, take, takeUntil, switchMap } from 'rxjs';
import { Picklist_HardfacingDetail, Picklist_RingGauge, FixedCutterPreBOMInput, BOM_FixedCutterInput, BomPartTypeLayout } from '../../interfaces/request';
import { OptionState } from '../../store/state/options.state';
import { RequestState } from '../../store/state/request.state';
import { CombinedSelectors } from '../../store/state/combined.selectors';
import { AccountState } from '../../store/state/account.state';
import { PartelementDataComponent } from '../populatesap-subcomponents/partelement-data/partelement-data.component';
import { RTAApiClient } from '../../services/rta-api.service';
import { FileVaultApiService, BomDocumentLink } from '../../services/filevault-api.service';

import { PartElementsActions } from '../../store/action/partelements.action';
import { GlobalNotificationService } from '../../services/globalnotification.service';

declare var CURRENT_USER_ID: number;

@Component({
    selector: 'app-populatesap-data',
    templateUrl: './populatesap-data.component.html',
    styleUrl: './populatesap-data.component.css',
    standalone: false
})
export class PopulatesapDataComponent {
  @ViewChild(PartelementDataComponent) gridComponent!: PartelementDataComponent;
  @ViewChildren(PartelementDataComponent) gridComponents!: QueryList<PartelementDataComponent>;

  @Input() draftId?: number;
  @Input() request$!: Observable<IORD_Order | undefined>;
  public appPopulateSapData!: FormGroup;
  constructor(
    private store: Store, 
    private fb: FormBuilder, 
    private service: RTAApiClient, 
    private globalNotificationService: GlobalNotificationService,
    private fileVaultService: FileVaultApiService
  ) {
    this.appPopulateSapData = this.fb.group({
      cutterProfileShape: [null, Validators.required],
      cutterDensity: [null, Validators.required],
      bitMakeUpLength: [null, Validators.required],
      shankDiameter: [null, Validators.required],
      heightToWidthRatio: [{ value: null, disabled: true }],
      padAngle: [{ value: null, disabled: true }],
      junkSlotArea: [null, Validators.required],
      normalizedFaceVolume: [null, Validators.required],
      bitOverAllLength: [null, Validators.required],
      blankLength: [null, Validators.required],
      bottomMoldLength: [null, Validators.required],
      topMoldLength: [null, Validators.required],
      isTrackSet: [{ value: null, disabled: true }],
      multiLevelForceBalance: [{ value: null, disabled: true }],
      onePiece: [{ value: null, disabled: true }],
      electronics: [null],
      bitBreaker: [null],
      upperSection: [null],
      restrictor: [false],
      shortShank: [false],
      showAllUpperSection: [false],
      sleeveLength: [null],
      sleeveGauge: [null],
      sleeveType: [null],
      sleeveExposure: [null],
      sleeveGaugeDrawingNumber: [null],
      roughLength: [null],
      cuttersOnSleeve: [false],
    });
    
    this.rtaBomLayout$ = this.store.select(OptionState.getBomLayout);
   }

  public electronics_Data$!: Observable<any[]>;
  public uppersection_Data$!: Observable<any[]>;
  public groupedBomItems: { [key: string]: any[] } = {};
  public picklists: { [key: string]: any[] } = {};

  public bomTypeNames: string[] = [];;
  public GraphiteBars$!: Observable<any[]>;
  public GaugePadElements$!: Observable<any[]>;
  public PowderBinderElements$!: Observable<any[]>;
  public NozzleDummyElements$!: Observable<any[]>;
  public rtaBomLayout$!: Observable<BomPartTypeLayout[]>;
  public fixedcutterSapData!:  Observable<BOM_FixedCutterInput>;
  private destroy$ = new Subject<void>();

  public BitFeatures_Data: any[] = [];
  public Electronics_Data: any[] = [];
  public Uppersections_Data: any[] = [];
  public APIs_Data: any[] = [];
  public HardFacingDetailLookUp: Picklist_HardfacingDetail[] = [];
  public HardFacingSleeveLookup: any[] = [];
  public BomMaskingDetail: Picklist_HardfacingDetail[] = [];
  public BomMaskingSleeve: any[] = [];
  public BomSacrificalDetail: any[] = [];
  public AngleBoxDetail: any[] = [];
  public BomSacrificalSleeve: any[] = [];
  public BomImpactArrestorGeo: any[] = [];
  public BomImpactArrestorLoc: any[] = [];
  public BomImpactDiskDensity: any[] = [];
  public BomSleeveExposure: any[] = [];
  public BomSleeveGauge: any[] = [];
  public BomSleeveGaugeType: any[] = [];
  public BomUpperSection: any[] = [];
  public GaugeByBitSize: Picklist_RingGauge[] = [];
  public filtered_BomUpperSection: any[] = [];
  public BomSleeveType: any[] = [];
  public BitBreakers: any[] = [];

  public bomItems: Observable<any[]> = of([]);


  public componentsLoaded: number = 0;
  public chunks = 14;
  public chunkSize = (this.chunks / 100)

  
  groupBy<T>(array: T[], key: (item: T) => string): { [key: string]: T[] } {
      return array.reduce((result: { [key: string]: T[] }, currentItem) => {
        const groupKey = key(currentItem);
        if (!result[groupKey]) {
          result[groupKey] = [];
        }
        result[groupKey].push(currentItem);
        return result;
      }, {} as { [key: string]: T[] });
    }
  ngOnInit(): void {
    this.electronics_Data$ = this.store.select(OptionState.electronics);
    this.uppersection_Data$ = this.store.select(CombinedSelectors.getfilteredUppersections);
    
    this.fixedcutterSapData = this.store.select(RequestState.fixedCutterPreInput);
    this.fixedcutterSapData.pipe(takeUntil(this.destroy$)).subscribe((sapData) => {
      if (sapData) {  
        this.bomItems = of(sapData.fixedCutterBoMItems.map(item => ({
          id: item.id,
          preBOMID: item.preBOMID,
          bomPartType_Id: item.bomPartType.id,
          quantity: item.quantity,
          type: item.description,
          picklist: item.bomPartType.pickListName,
          sapMaterialNumber: item.sapMaterialNumber
        })));

        this.appPopulateSapData.patchValue({
          ...sapData,
        }, { emitEvent: false });
      }
    });
    
    // Fetch partId from the order's SAP numbers (Type 3 = Bit Material)
    this.request$.pipe(
      takeUntil(this.destroy$),
      switchMap(order => {
        if (!order || !order.sapNumbers || order.sapNumbers.length === 0) {
          return of(null);
        }

        const bitMaterial = order.sapNumbers.find(
          sap => (sap.sapNumTypeId === 3 || sap.sapNumType?.id === 3)
        );

        if (!bitMaterial || !bitMaterial.number) {
          return of(null);
        }

        // Fetch the partId from FileVault API
        return this.fileVaultService.getPartIdByPartNumber(bitMaterial.number.toString());
      })
    ).subscribe({
      next: (response) => {
        console.log('Part ID response from FileVault API:', response);
        if (response && response.id) {
          this.partId = response.id.toString();
        }
      },
      error: (error) => {
        console.error('Error fetching partId:', error);
        // Don't show error notification, just log it
      }
    });
    
      
    // this.service.getBomImpactArrestorGeos().subscribe(response => { this.BomImpactArrestorGeo = response['data']; this.componentsLoaded++; });
    // this.service.getBomImpactArrestorLocs().subscribe(response => { this.BomImpactArrestorLoc = response['data']; this.componentsLoaded++; });
    // this.service.getBomImpactDiskDensities().subscribe(response => { this.BomImpactDiskDensity = response['data']; this.componentsLoaded++; });
    // this.service.getStandardParts_AllUpperSections().subscribe(response => { this.BomUpperSection = response['data']; this.getListofUpperSections(); this.componentsLoaded++; });
    // this.service.getRingGauges(this.Request.order.Bit[0].Size.toString()).subscribe(response => { this.GaugeByBitSize = response['data']; this.componentsLoaded++; });
    // this.service.getBitBreakers(this.Request.order.Id, this.Request.fixedCutterSapData.FixedCutterInput.UpperSection, this.Request.fixedCutterSapData.FixedCutterInput.ShortShank, false).subscribe(response => {
    //   this.BitBreakers = response['data'].filter((x) => x.SAPNumber !== '0').map((x) => `${x.SAPNumber}-${x.DrawingNumber}`)
    //   this.BitBreakers.push("No Bit Breaker");
    //   this.componentsLoaded++;
    // });
    // if (this.Request.fixedCutterSapData.Sleeve) {
    //   this.service.getBomSleeveExposures().subscribe(response => { this.BomSleeveExposure = response['data']; this.componentsLoaded++; });
    //   this.service.getBomSleeveGauges(this.Request.order.Bit[0].Size.toString()).subscribe(response => { this.BomSleeveGauge = response['data']; this.componentsLoaded++; });
    //   this.service.getBomSleeveGaugeTypes().subscribe(response => { this.BomSleeveGaugeType = response['data']; this.componentsLoaded++; });
    //   this.service.getBomSleeveTypes().subscribe(response => { this.BomSleeveType = response['data']; this.componentsLoaded++; });
    // }
  }
  public pushBOMToSAP(): void {
    // Get the order and use the global CURRENT_USER_ID
    this.request$.pipe(
      takeUntil(this.destroy$),
      switchMap(order => {
        if (!order || !order.id) {
          throw new Error('Order not found.');
        }

        if (!CURRENT_USER_ID) {
          throw new Error('User ID not found. Please ensure you are logged in.');
        }

        console.log('Pushing BOM to SAP - Order ID:', order.id, 'User ID:', CURRENT_USER_ID);

        this.globalNotificationService.showInfoNotification('Creating BOM in SAP...');
        return this.service.createMaterialBom(order.id, CURRENT_USER_ID);
      })
    ).subscribe({
      next: (response) => {
        if (response.status) {
          this.globalNotificationService.showSuccessNotification(
            response.message || 'BOM created in SAP successfully.'
          );
        } else {
          this.globalNotificationService.showErrorNotification(
            response.message || 'Failed to create BOM in SAP.'
          );
        }
      },
      error: (error) => {
        this.globalNotificationService.showErrorNotification(
          error.message || 'An error occurred while creating BOM in SAP.'
        );
        console.error('Error creating BOM in SAP:', error);
      }
    });
  }
  public saveBOM(): void {
    // Collect all BOM items from all partelement-data grid components
    const allItems: { id: number; preBOMID: number; type: string; sapMaterialNumber: number; quantity: number }[] = [];

    this.gridComponents.forEach(grid => {
      grid.localElementsData.forEach(item => {
        allItems.push({
          id: item.id || 0,
          preBOMID: item.preBOMID || 0,
          type: item.type || '',
          sapMaterialNumber: item.sapMaterialNumber || 0,
          quantity: item.quantity || 0
        });
      });
    });

    if (allItems.length === 0) {
      this.globalNotificationService.showWarningNotification('No BOM items to save.');
      return;
    }

    this.request$.pipe(
      take(1),
      switchMap(order => {
        if (!order || !order.id) {
          throw new Error('Order not found.');
        }

        if (!CURRENT_USER_ID) {
          throw new Error('User ID not found. Please ensure you are logged in.');
        }

        this.globalNotificationService.showInfoNotification('Saving BOM...');
        return this.service.saveBom(order.id, CURRENT_USER_ID, { items: allItems });
      })
    ).subscribe({
      next: (response) => {
        if (response.status) {
          this.globalNotificationService.showSuccessNotification(
            response.message || 'BOM saved successfully.'
          );
          // Clear change tracking on all grids after successful save
          this.gridComponents.forEach(grid => grid.clearChanges());
        } else {
          this.globalNotificationService.showErrorNotification(
            response.message || 'Failed to save BOM.'
          );
        }
      },
      error: (error) => {
        this.globalNotificationService.showErrorNotification(
          error.message || 'An error occurred while saving BOM.'
        );
        console.error('Error saving BOM:', error);
      }
    });
  }
  public generateSapData() {
    if (!this.draftId) {
      return;
    }

    this.globalNotificationService.showInfoNotification('Generating SAP data...');
    this.service.generateSapData(this.draftId).subscribe({
      next: (response) => {
        if (response.status) {
          this.globalNotificationService.showSuccessNotification(
            response.message || 'SAP data generated successfully.'
          );
        } else {
          this.globalNotificationService.showErrorNotification(
            response.message || 'Failed to generate SAP data.'
          );
        }
      },
      error: (error) => {
        this.globalNotificationService.showErrorNotification(
          error.message || 'An error occurred while generating SAP data.'
        );
        console.error('Error generating SAP data:', error);
      }
    });
  }

  public processRTADrawings(): void {
    // Get the order and use the global CURRENT_USER_ID
    this.request$.pipe(
      takeUntil(this.destroy$),
      switchMap(order => {
        if (!order || !order.id) {
          throw new Error('Order not found.');
        }

        if (!CURRENT_USER_ID) {
          throw new Error('User ID not found. Please ensure you are logged in.');
        }

        console.log('Processing RTA Drawings - Order ID:', order.id, 'User ID:', CURRENT_USER_ID);

        this.globalNotificationService.showInfoNotification('Creating documents in SAP...');
        return this.service.processRTADrawings(CURRENT_USER_ID, order.id);
      })
    ).subscribe({
      next: (response) => {
        if (response.status) {
          this.globalNotificationService.showSuccessNotification(
            response.message || 'Documents created in SAP successfully.'
          );
        } else {
          this.globalNotificationService.showErrorNotification(
            response.message || 'Failed to create documents in SAP.'
          );
        }
      },
      error: (error) => {
        this.globalNotificationService.showErrorNotification(
          error.message || 'An error occurred while creating documents in SAP.'
        );
        console.error('Error processing RTA drawings:', error);
      }
    });
  }

  public getBomItemByType (id: number): Observable<any[]> {
    return this.bomItems.pipe(
      map(items => items.filter(item => item.bomPartType_Id === id))
    )
  }
  triggerGridSave() {
    this.gridComponent.triggerSave();
  }
  onElementsUpdated(event: { partKey: string; elements: PatchPartElementDto[] }) {
    console.log('Dispatching UpdatePartElements:', event.partKey, event.elements);
  
    // Update the store (local state)
    this.store.dispatch(new PartElementsActions.UpdatePartElements({ partKey: event.partKey, elements: event.elements }));
    
    // TODO: Call API to persist changes to backend
    // For now, changes are only stored locally in NgXs store
    // You may need to call an API like:
    // this.service.updatePartElements(this.draftId, event.elements).subscribe(...)
    
    // Show notification that changes are tracked but need to be saved
    this.globalNotificationService.showInfoNotification(
      'Changes tracked. Use "Push to SAP" or save the order to persist these changes.'
    );
  }
  ngOnChanges(changes: SimpleChanges): void {
      const ch = changes['bitInitial'];
      if (ch && ch.currentValue) {
        const b = ch.currentValue as BOM_FixedCutterInput;
        this.appPopulateSapData.patchValue({
          ...b,
        });
      }
    }
  private processOptions(options: RTAOptions[]) {
    options.forEach(element => {
      switch (element.field) {
        case 'Electronics': {
          const ElectronicsData: any[] = [];
          const Electronics = JSON.parse(element.fieldOptions!);
          Electronics.forEach((data: any) => {
            ElectronicsData.push({ value: data.value, name: data.name });
          })
          this.Electronics_Data = ElectronicsData;
          break;
        }
        case 'Uppersection': {
          const Uppersections = JSON.parse(element.fieldOptions!);
          this.BomUpperSection = Uppersections;
          break;
        }
        case 'APIs': {
          const Apis = JSON.parse(element.fieldOptions!);
          this.APIs_Data = Apis;
          break;
        }
        case 'BitFeature': {
          const BitFeatureData: any[] = [];
          let BitFeatures = JSON.parse(element.fieldOptions!);
          BitFeatures.forEach((data: any) => {
            BitFeatureData.push({ value: data.value, name: data.name, marketsheet: data.IsDisplayedInMarketingSheet, costsaving: data.IsCostSavingFeature, subcat: data.subcat, subPSL: data.subPSL });
          })
          this.BitFeatures_Data = BitFeatureData;
          break;
        }
      }
    });
  }
  public processPicklistData(jsonData: string): any[] {
    return jsonData ? JSON.parse(jsonData) : [];
  }
  // expandPanel() {
  //   if (this.componentsLoaded >= this.chunks) { return true; }
  //   else { return false; }
  // }

  // getListofUpperSections() {
  //   if (this.Request.isLoadingSAPData) { return null; }
  //   return this.filtered_BomUpperSection = this.BomUpperSection.filter(x => x.Comments === this.Request.fixedCutterSapData.FixedCutterInput.APISize);
  // }
  // handleUpperSectionFilter(value) {
  //   this.filtered_BomUpperSection = this.BomUpperSection.filter(
  //     (s) => s.DrawingNumber.toLowerCase().indexOf(value.toLowerCase()) !== -1 && s.Comments === this.Request.fixedCutterSapData.FixedCutterInput.APISize
  //   );
  // }
  // checkUpperSection_Electronic() {
  //   if (this?.BomUpperSection.length === 0) { return false; }
  //   if (this.Request.fixedCutterSapData.OnePiece) { return false; }
  //   var _selectedUpperSection = this.BomUpperSection.filter((x) => x.DrawingNumber === this.Request.fixedCutterSapData.FixedCutterInput.UpperSection);
  //   if (_selectedUpperSection[0]?.Electronics_Id || _selectedUpperSection[0]?.Electronics_Id === 0) { return false; }
  //   else { return true; }
  // }
  // updateElectronicSelection() {
  //   console.log(this.Request.fixedCutterSapData.FixedCutterInput.UpperSection)
  //   var _selectedUpperSection = this.BomUpperSection.filter((x) => x.DrawingNumber === this.Request.fixedCutterSapData.FixedCutterInput.UpperSection);
  //   if (_selectedUpperSection[0].Electronics_Id === 0 || _selectedUpperSection[0].Electronics_Id === null) { this.Request.fixedCutterSapData.FixedCutterInput['Electronics'] = _selectedUpperSection[0].Electronics_Id }
  //   this.BitBreakers = [];
  //   this.service.getBitBreakers(this.Request.order.Id, this.Request.fixedCutterSapData.FixedCutterInput.UpperSection, this.Request.fixedCutterSapData.FixedCutterInput.ShortShank, false).subscribe(response => {
  //     this.BitBreakers = response['data'].filter((x) => x.SAPNumber !== '0').map((x) => `${x.SAPNumber}-${x.DrawingNumber}`)
  //     this.BitBreakers.push("No Bit Breaker")
  //   });
  // }

  // Import from SAP functionality
  public showImportDialog = false;
  public isLoadingBomItems = false;
  public sapBomItems: SapBomItem[] = [];
  public selectedBomItems: string[] = [];
  public bomImportError: string | null = null;
  public hasDocumentInfo = false;
  public partId: string | null = null;

  importFromSAP(): void {
    this.bomImportError = null;
    this.sapBomItems = [];
    this.selectedBomItems = [];
    
    // Get the reference material number (SAPNumTypeId = 1)
    this.request$.pipe(takeUntil(this.destroy$)).subscribe(order => {
      if (!order || !order.sapNumbers || order.sapNumbers.length === 0) {
        this.bomImportError = 'No SAP numbers found for this order.';
        this.showImportDialog = true;
        return;
      }

      const referenceMaterial = order.sapNumbers.find(
        sap => (sap.sapNumTypeId === 1 || sap.sapNumType?.id === 1)
      );

      if (!referenceMaterial || !referenceMaterial.number) {
        this.bomImportError = 'Reference material (SAP Number Type 1) not found.';
        this.showImportDialog = true;
        return;
      }

      this.showImportDialog = true;
      this.isLoadingBomItems = true;

      // Call the API
      this.service.getMaterialBoM(referenceMaterial.number.toString(), '2130').subscribe({
        next: (response) => {
          this.isLoadingBomItems = false;
          
          if (!response.status) {
            this.bomImportError = response.message || 'Failed to retrieve BOM from SAP.';
            return;
          }

          // Parse the data from response
          const bomData = (response as any).info;
          if (!bomData || !Array.isArray(bomData)) {
            this.bomImportError = 'Invalid BOM data received from SAP.';
            return;
          }

          // Filter and map BOM items, excluding items with null/empty document fields
          this.sapBomItems = bomData
            .filter((item: any) => {
              // Include items that have at least one non-null document field
              return item.documentType || item.docNumber || item.documentVersion || item.documentPart;
            })
            .map((item: any, index: number) => ({
              itemNumber: item.itemNumber || (index + 1).toString(),
              materialNumber: item.materialNumber || '',
              materialDescription: item.componentDescription || item.description || '',
              quantity: item.quantity || 0,
              unit: item.unit || item.unitOfMeasure || '',
              documentType: item.documentType || '',
              docNumber: item.docNumber || '',
              documentVersion: item.documentVersion || '',
              documentPart: item.documentPart || ''
            }));

          // Check if any items have document information
          this.hasDocumentInfo = this.sapBomItems.some(item => 
            item.documentType || item.docNumber || item.documentVersion || item.documentPart
          );

          if (this.sapBomItems.length === 0) {
            this.bomImportError = 'No BOM items with document information found.';
          }
        },
        error: (error) => {
          this.isLoadingBomItems = false;
          this.bomImportError = error.message || 'An error occurred while fetching BOM data from SAP.';
          console.error('Error fetching BOM from SAP:', error);
        }
      });
    });
  }

  closeImportDialog(): void {
    this.showImportDialog = false;
    this.sapBomItems = [];
    this.selectedBomItems = [];
    this.bomImportError = null;
  }

  confirmImport(): void {
    if (this.selectedBomItems.length === 0) {
      this.globalNotificationService.showWarningNotification('Please select at least one BOM item to import.');
      return;
    }

    // Get the selected items
    const itemsToImport = this.sapBomItems.filter(item => 
      this.selectedBomItems.includes(item.itemNumber)
    );

    console.log('Items to import:', itemsToImport);
    
    // Get the current user and order to prepare the payload
    const currentUser$ = this.store.select(AccountState.user);
    
    this.request$.pipe(
      takeUntil(this.destroy$),
      switchMap(order => {
        if (!order || !order.sapNumbers) {
          throw new Error('Order or SAP numbers not found.');
        }

        // Get the reference material number (SAPNumTypeId = 3)
        const referenceMaterial = order.sapNumbers.find(
          sap => (sap.sapNumTypeId === 3 || sap.sapNumType?.id === 3)
        );

        if (!referenceMaterial || !referenceMaterial.number) {
          throw new Error('Bit material (SAP Number Type 3) not found.');
        }

        const partNumber = referenceMaterial.number.toString();

        return currentUser$.pipe(
          map(user => ({ partNumber, user }))
        );
      }),
      switchMap(({ partNumber, user }) => {
        // Map selected BOM items to the API payload format
        const documents: BomDocumentLink[] = itemsToImport.map(item => ({
          partNumber: item.materialNumber,
          documentNumber: item.docNumber,
          documentVersion: item.documentVersion,
          documentPart: item.documentPart,
          documentType: item.documentType,
          title: item.materialDescription || '',
          description: item.materialDescription || '',
          bomItemNumber: item.itemNumber,
          bomItemCategory: '', // Can be populated if available in BOM data
          createdBy: user.loginID || user.displayName || 'System'
        }));

        const payload = {
          partNumber: partNumber,
          documents: documents
        };

        console.log('Linking BOM documents to FileVault:', payload);

        // Call the FileVault API
        return this.fileVaultService.linkBomDocuments(payload);
      })
    ).subscribe({
      next: (response) => {
        this.globalNotificationService.showSuccessNotification(
          `Successfully linked ${itemsToImport.length} BOM document(s) to FileVault.`
        );
        this.closeImportDialog();
      },
      error: (error) => {
        console.error('Error linking BOM documents:', error);
        this.globalNotificationService.showErrorNotification(
          `Failed to link BOM documents: ${error.message || 'Unknown error'}`
        );
      }
    });
  }
 getBitFeatureIds(order: IORD_Order | undefined): number[] {
    return (order?.orderFeatureAssociations ?? [])
      .map(feature => feature.bitFeatureID)
      .filter((id): id is number => typeof id === 'number');
  }
  // ngOnDestroy(): void {
  //   this.destroy$.next();
  //   this.destroy$.complete();
  // }
}

// Interface for SAP BOM Items
interface SapBomItem {
  itemNumber: string;
  materialNumber: string;
  materialDescription: string;
  quantity: number;
  unit: string;
  documentType: string;
  docNumber: string;
  documentVersion: string;
  documentPart: string;
}

